module.exports = __webpack_public_path__ + "img/4d.f2f9c5cd.gif";